export default __webpack_public_path__ + "static/media/edit_selected_on_over.470519f9.svg";